var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ellipsis_icon_clip)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color)"
    },
    d: "M7 14.0625C6.27513 14.0625 5.6875 13.4749 5.6875 12.75C5.6875 12.0251 6.27513 11.4375 7 11.4375C7.72487 11.4375 8.3125 12.0251 8.3125 12.75C8.3125 13.4749 7.72487 14.0625 7 14.0625ZM5.6875 7.5C5.6875 8.22487 6.27513 8.8125 7 8.8125C7.72487 8.8125 8.3125 8.22487 8.3125 7.5C8.3125 6.77513 7.72487 6.1875 7 6.1875C6.27513 6.1875 5.6875 6.77513 5.6875 7.5ZM5.6875 2.25C5.6875 2.97487 6.27513 3.5625 7 3.5625C7.72487 3.5625 8.3125 2.97487 8.3125 2.25C8.3125 1.52513 7.72487 0.9375 7 0.9375C6.27513 0.9375 5.6875 1.52513 5.6875 2.25Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ellipsis_icon_clip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(14 0.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.8af838830daeb233e742d2dbba7dad91.svg";
export { ForwardRef as ReactComponent };